import INFTProperties from '../../../models/INFTProperties'
import { CheckUrl } from '../../../utils/CheckUrl'

export function validateTitle(value: any) {
  let error
  if (!value) {
    error = 'Title is required'
  }
  return error
}

export function validateProperties(props: INFTProperties[]): string | undefined {
  const mapValues: string[] = props
    .filter((item: INFTProperties) => item.show)
    .map((item: INFTProperties, index) => {
      let mapError = ''
      if (item.show && item.value && !item.key) {
        mapError = `${item.value} is not allowed to be empty key`
      } else if (item.show && !item.value && item.key) {
        mapError = `${item.key} is not allowed to be empty value`
      }

      return mapError
    })

  const filteredValues = mapValues.filter((item: string | null) => item !== '')

  return filteredValues.length > 0 && filteredValues[0] ? filteredValues[0] : undefined
}

const coverTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
const fileTypes = [...coverTypes, 'video/mp4', 'video/webm', 'audio/mp3', 'audio/webm', 'audio/mpeg']
const fileTypesText = 'PNG, GIF, WEBP, MP4 or MP3'
const coverTypesText = 'JPG, PNG, GIF or WEBP'
export function validateFile(value: any, type: 'file' | 'cover') {
  let error
  const name = type === 'file' ? 'File' : 'Cover'
  const typesCheck = type === 'file' ? fileTypes : coverTypes
  const typesText = type === 'file' ? fileTypesText : coverTypesText
  const file = value && value.file ? value.file : value

  if (!file) {
    error = `${name} is required`
  } else if (file && typesCheck.indexOf(file.type) === -1) {
    error = `Acceptable file formats for ${name} ${typesText}`
  } else if (file && Math.round(file.size / 1024) > 10240) {
    error = `${name} file size should be less than 10mb`
  }
  return error
}

export function validateRoyalties(value: number, max: number) {
  let error
  if (value > max) {
    error = `Royalties are not allowed than 15%`
  }
  return error
}

export function validateExtendUrl(url: string) {
  let error
  if (url) {
    const isValidUrl = CheckUrl(url)

    if (!isValidUrl) {
      error = `Please enter a valid url`
    }
  }
  return error
}
